import React, { useEffect, useState } from "react";
import { GetMembers } from "./API";
import { Link } from "react-router-dom";

export default function Members(props) {
  const [data, setData] = useState([]);
  useEffect(() => {
    GetMembers(props.match.params.crsnum).then(data => {
      setData(data);
      console.log(data);
    });
  }, []);
  return (
    <div className="row row-space-2 m-t-10">
      {data.map(item => (
        <MembersItem item={item} />
      ))}
    </div>
  );
}

function MembersItem(props) {
  return (
    <div class="col-md-6 m-b-2">
      <div class="p-10 bg-white">
        <div class="media media-xs overflow-visible">
          <a class="media-left" href="">
            <img
              src={`api/General/Image/${props.item.regnum}`}
              alt=""
              class="media-object img-circle height-40"
            />
          </a>
          <div class="media-body valign-middle">
            <b class="text-inverse text-ellipsis">{props.item.name}</b>
            <br />
            {props.item.regnum}
          </div>
          <div class="media-body valign-middle text-right overflow-visible">
            <Link
              to={`/chatservice/${props.item.regnum}`}
              className="btn btn-primary"
            >
              <i class="fas fa-fw fa-paper-plane" /> Send Message{" "}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Members/Members.js